import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { ProjectContextProvider } from '@atlassian/jira-providers-project-context';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import ServiceDeskAppBase from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/app-base/index.tsx';
import { ServiceDeskDocumentTitle } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/document-title/index.tsx';
import { WidgetSettingsApp } from '@atlassian/jira-servicedesk-widget-settings/src/ui/main.tsx';
import AppContainer from '@atlassian/jira-spa-apps-project-settings-common/src/components/app-container';
import { ProjectSettingsController } from '@atlassian/jira-spa-apps-project-settings-common/src/components/routing-filter';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { type RouteContext, withRouter } from '@atlassian/react-resource-router';

const TEAM_NAME = 'itops-mithril';
const ERROR_BOUNDARY_ID = 'projectSettingsAppsServiceDeskWidgetSettings';
const PACKAGE_NAME = 'jiraSpaAppsProjectSettingsServiceDeskWidgetSettings';
const SECTION = 'widget';

type Props = RouteContext;
export function ServiceDeskWidgetSettingsPage(props: Props) {
	const { projectKey } = props.match.params;
	return (
		<ProjectSettingsController projectKey={projectKey}>
			<MarkProductStart />
			<ServiceDeskAppBase appName={APP_NAMES.WIDGET_SETTINGS}>
				<JSErrorBoundary id={ERROR_BOUNDARY_ID} teamName={TEAM_NAME} packageName={PACKAGE_NAME}>
					<TenantContextSubscriber>
						{({ tenantContext }) => (
							<ProjectContextProvider>
								{(projectContext) =>
									projectContext.data?.projectKey ? (
										<>
											<ServiceDeskDocumentTitle
												projectName={projectContext.data.projectName}
												section={SECTION}
											/>
											<AppContainer baseUrl="" projectKey={projectContext.data?.projectKey}>
												<WidgetSettingsApp
													baseUrl={tenantContext.baseUrl}
													locale={tenantContext.locale}
													projectKey={projectContext.data?.projectKey}
													projectId={projectContext.data?.projectId}
												/>
											</AppContainer>
										</>
									) : (
										<Spinner />
									)
								}
							</ProjectContextProvider>
						)}
					</TenantContextSubscriber>
				</JSErrorBoundary>
			</ServiceDeskAppBase>
		</ProjectSettingsController>
	);
}

export default withRouter(ServiceDeskWidgetSettingsPage);
